export const GET_NOTIFICATIONS_REQUEST = 'GET_NOTIFICATIONS_REQUEST';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAILURE = 'GET_NOTIFICATIONS_FAILURE';
export const RESET_UNREAD_REQUEST = 'RESET_UNREAD_REQUEST';
export const RESET_UNREAD_SUCCESS = 'RESET_UNREAD_SUCCESS';
export const RESET_UNREAD_FAILURE = 'RESET_UNREAD_FAILURE';
